(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[197],{

/***/ 2448:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(1635);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7320);
/* harmony import */ var _io_components_Meta__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8549);
/* harmony import */ var _io_components_Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7673);
/* harmony import */ var _io_components_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5315);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var MainLayout = function(_param) {
    var children = _param.children, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    var tagline = props.tagline;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_io_components_Meta__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({}, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_io_components_Header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("main", {
                id: "main-content",
                className: "flex flex-col justify-center w-full mx-auto max-w-5xl pb-10 px-5 sm:px-10 mb-4",
                children: [
                    tagline && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("h1", {
                        className: "pt-10 xs:pt-5 sm:pt-2 mb-8 title-font text-5xl lg:text-4xl xl:text-5xl font-bold tracking-tighter text-left text-gray-800 dark:text-gray-100",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                            className: "decoration-clone bg-clip-text text-transparent bg-gradient-to-r from-primary-300 to-green-500",
                            children: tagline
                        })
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_io_components_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (MainLayout);


/***/ }),

/***/ 1635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9776);

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (_error__WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ }),

/***/ 9776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _error; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs
var jsx_runtime = __webpack_require__(7320);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 28 modules
var esm = __webpack_require__(7985);
// EXTERNAL MODULE: ./layouts/MainLayout.js
var MainLayout = __webpack_require__(6948);
// EXTERNAL MODULE: ./components/ExternalLink.js
var ExternalLink = __webpack_require__(3778);
;// CONCATENATED MODULE: ./public/static/images/khaby-lame-by-gabriel-soares.png
/* harmony default export */ var khaby_lame_by_gabriel_soares = ({"src":"/_next/static/media/khaby-lame-by-gabriel-soares.20f28c44.png","height":1177,"width":1080,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAP1BMVEVMaXFsSGRhOnSUaldpS3VuR15/Y5F7V0ttTluoiMV1W1R9WYJZNC1PKlovDj6WeKKlfaGGaneUbnRwSXB5VDtE1Af+AAAAE3RSTlMAp8SN/f5H/D82jvn++vd8eby7pDYPmAAAAAlwSFlzAAALEwAACxMBAJqcGAAAADdJREFUCJk9xUkSgCAQBMECGXrABRD//1YDD+Yl4efy7/psq5KOvQDNrtmBoVM35CTTzHgMFqK/IBQBOpriBqkAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./pages/_error.js

// import Link from 'next/link'





var Error = function(param) {
    var statusCode = param.statusCode;
    var t = (0,esm/* useTranslation */.$G)('error').t;
    var pageTitle = t('error-404-page-title');
    var title = t('error-404-title');
    var description = t('error-404-description');
    if (statusCode !== 404) {
        pageTitle = t('error-page-title');
        title = t('error-title');
        description = t('error-description');
    }
    return(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MainLayout/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            className: "flex flex-col justify-center px-4 text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h1", {
                    className: "mt-10 mb-4 font-bold text-3xl md:text-5xl tracking-tight text-gray-800 dark:text-gray-50",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                    className: "text-gray-700 dark:text-gray-50",
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "flex justify-center mx-auto max-w-xl",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_image["default"], {
                        alt: "Khaby Lame (TikTok actor), drawing in 3D by Gabriel Soares",
                        src: khaby_lame_by_gabriel_soares,
                        layout: "intrinsic",
                        placeholder: "blur",
                        blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN0kvOrBwAChwEvE4ju7gAAAABJRU5ErkJggg==",
                        priority: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                    className: "mb-1 text-center text-xs italic",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ExternalLink/* default */.Z, {
                        href: "https://www.instagram.com/gabriel.soareszz/",
                        classNames: "text-purple-500 hover:text-purple-400",
                        children: t('drawing-credits')
                    })
                })
            ]
        })
    }));
};
var __N_SSG = true;
/* harmony default export */ var _error = (Error);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [22,477,888,179], function() { return __webpack_exec__(2448); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);